// extracted by mini-css-extract-plugin
module.exports = {"avatar-right":"_1wLJd","avatarRight":"_1wLJd","avatar-left":"_1BivC","avatarLeft":"_1BivC","container":"dqEEU"};